import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "../../..";
import StorageItems from "../../../../storage";
import { generateMessageReturn } from "../../../../utils/messageFuncs";

const auth = new StorageItems().get("authToken");

class ApiConfigTokens extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  token;
  basePath = "configs/tokens";
  constructor(data?: any) {
    super();
    this.token = auth?.authToken;

    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.token ? `Bearer ${this.token}` : "",
      },
    };

    if (data) {
      this.data = data;
      this.config.data = data;
    }
  }

  list = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/list`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Listar Tokens (assinaturas)",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  update = async (id: string) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/update/${id}`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Atualização de Tokens (assinaturas)",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  create = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/create`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Criação de Token (assinaturas)",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  delete = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/${this.data.id_token}`;
    this.config.method = "delete";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Remoção de token (assinaturas)",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };
}

export default ApiConfigTokens;
